import React from 'react';
import { StarIcon } from 'lucide-react';
import { Card } from '../ui/Card';
export function Testimonials() {
  const testimonials = [{
    name: 'Carolina M.',
    text: 'Llevaba años sintiéndome hinchada después de cada comida. En la primera semana la diferencia fue notable, mi ropa ya no me aprieta en la tarde.',
    stars: 5
  }, {
    name: 'Andrea R.',
    text: 'Lo mejor es que no pasas hambre. Las recetas son ricas y el sistema del semáforo hace que sea muy fácil decidir qué comer sin pensarlo tanto.',
    stars: 5
  }, {
    name: 'Valentina S.',
    text: 'Intenté muchos detox de jugos y siempre los dejaba. Esto es comida real. Me siento con mucha más energía y sin esos antojos locos de la noche.',
    stars: 5
  }];
  return <section className="py-16 md:py-24 bg-white" data-id="element-200">
      <div className="container mx-auto px-4" data-id="element-201">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-202">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-203">
            Lo que dicen quienes ya empezaron
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-204">
          {testimonials.map((t, i) => <Card key={i} className="bg-stone-50 border-none" data-id="element-205">
              <div className="flex mb-4" data-id="element-206">
                {[...Array(t.stars)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-yellow-400 fill-current" data-id="element-207" />)}
              </div>
              <p className="text-stone-700 mb-6 italic" data-id="element-208">"{t.text}"</p>
              <p className="font-bold text-stone-900" data-id="element-209">{t.name}</p>
            </Card>)}
        </div>
      </div>
    </section>;
}